export const Functions = {
  create: false,
  delete: false,
  detail: false,
  search: true,
};

export const PageName = '白名单专项审核列表';
